module.exports = __webpack_public_path__ + "img/splash.aec3bd6a.png";